<template>
    <div :class="cardClass">
        <div class="card__avatar">
            <common-rating-avatar
                v-if="practice"
                :showPracticeAvatar="true"
                :rating="practice.professionalRating"
                :user="practice"
                :size="avatarSize"
                :isUserProfileLinkEnabled="false"
            ></common-rating-avatar>

            <p v-if="practice.professionalRating" :class="ratingClass">
                {{ (practice.professionalRating || 0).toFixed(1) }}
            </p>
        </div>

        <p :class="cardNameClass">
            {{ practice.name }}
        </p>

        <div v-if="!isUserJoined && invitedDate" class="card__invited-date">
            {{ $t('elements.referrals.card.invited_on', { date: invitedDate }) }}
        </div>

        <common-buttons v-if="!isUserJoined && invitedDate" class="card__reinvite">
            <common-button
                :label="$t('elements.referrals.card.buttons.reinvite_practice')"
                :isProcessing="isProcessingReinvite"
                size="medium-small"
                type="secondary"
                @click="reinviteUser(practice)"
            ></common-button>
        </common-buttons>

        <div v-if="practice.rating" :class="medmatchRatingClass">
            <common-rating-stars :rating="practice.rating"></common-rating-stars>
        </div>

        <p v-if="practice.referralsReceivedCount && showRefCount" class="card__referrals-count">
            <b>{{ practice.referralsReceivedCount }}</b>
            <span>{{ $t('elements.referrals.card.referrals') }}</span>
        </p>
        <slot></slot>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import UsersAPI from 'api/UsersAPI'

    export default {
        props: {
            practice: { type: Object, required: true },
            size: { type: String, default: 'large' },
            showRefCount: { type: Boolean, default: true },
            isUserProfileLinkEnabled: { type: Boolean, default: true },
            showInvitedDate: { type: Boolean, default: false },
        },

        data() {
            return {
                isProcessingReinvite: false,
            }
        },

        computed: {
            avatarSize() {
                switch (this.size) {
                    case 'medium':
                        return 'user-context'
                    default:
                        return 'member-switch'
                }
            },

            ratingClass() {
                return {
                    'card__professional-rating': true,
                    [`card__professional-rating--size-${this.size}`]: this.size,
                }
            },

            cardNameClass() {
                return {
                    card__name: true,
                    [`card__name--size-${this.size}`]: this.size,
                }
            },

            medmatchRatingClass() {
                return {
                    'card__medmatch-rating': true,
                    [`card__medmatch-rating--size-${this.size}`]: this.size,
                }
            },

            cardClass() {
                return {
                    card: true,
                }
            },

            invitedDate() {
                if (this.showInvitedDate && this.practice?.target?.dateCreated) {
                    return dayjs(this.practice.target.dateCreated).format('MMMM D, YYYY')
                }
                return null
            },

            isUserJoined() {
                return !!this.practice?.target?.dateJoined
            },
        },

        methods: {
            reinviteUser(user) {
                this.isProcessingReinvite = true
                const toEmail = user.target.name
                const toPhone = user.phone
                const userId = this.$auth.getActiveMember().id
                if (toPhone) {
                    UsersAPI.sendReminderForJoinInvite(
                        this.$auth.getActiveMember().id,
                        user.id,
                        'referral',
                        'create-practice',
                    ).then(() => {
                        this.isProcessingReinvite = false
                    })
                } else {
                    UsersAPI.getJoinInviteLink(toEmail, userId)
                        .then((res) => {
                            window.open(
                                this.$t('native_emails.reinvite', {
                                    recepientEmail: toEmail,
                                    link: encodeURIComponent(res.link),
                                }),
                                '_blank',
                            )
                            this.isProcessingReinvite = false
                        })
                        .catch(() => (this.isProcessingReinvite = false))
                }
            },
        },
    }
</script>
